// extracted by mini-css-extract-plugin
module.exports = {"lia-tag":"TagViewChip_lia-tag__XQ_Wo","lia-tag-text":"TagViewChip_lia-tag-text__iaqW0","lia-tag-item":"TagViewChip_lia-tag-item__V0MPu"};